// Otomasyon Şablonları: müşterinin Hedef ROAS'ı. Şablonlardaki "hedefin altında/üstünde" koşulları bu değeri kullanır.
// Girilmezse hesabın kendi son 30 günlük ROAS'ı referans alınır (sabit varsayılan yok). Backend: /automation/target-roas
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { T } from './poyais-ui/theme';
import { Button } from './poyais-ui/primitives';
import { useLang, addTranslations } from './i18n';
import { useIsMobile } from './poyais-ui/hooks';

addTranslations({
  'Hedef ROAS': 'Target ROAS',
  'Şablonlardaki "hedefin altında / üstünde" koşulları bu değere göre çalışır. Girmezsen hesabının son 30 günlük ROAS\'ı referans alınır.': 'The "below / above target" conditions in the templates work from this value. If you leave it empty, your account\'s own last-30-day ROAS is used as the reference.',
  'Hedef ROAS (×)': 'Target ROAS (×)',
  'Kaydet': 'Save',
  'Otomatiğe Dön': 'Use Automatic',
  'Kaydedildi': 'Saved',
  'otomatik': 'automatic',
  'veri yok': 'no data yet',
  'Hedef kaydedildi.': 'Target saved.',
  'Hedef 0,5 ile 50 arasında olmalı.': 'Target must be between 0.5 and 50.',
  'Kaydedilemedi.': 'Could not save.',
  'Şu an kullanılan': 'Currently used',
});

export type TargetInfo = { manual: number | null; auto: { meta: number | null; google: number | null } };
const API = '/api/v1/automation/target-roas';

export default function TargetRoasCard({ clientId, info, onChange, showToast }:
  { clientId: number; info: TargetInfo | null; onChange: () => void; showToast: (m: string) => void }) {
  const { t } = useLang();
  const isMobile = useIsMobile();
  const [val, setVal] = useState('');
  const [busy, setBusy] = useState(false);
  const [saved, setSaved] = useState(false);
  useEffect(() => { setVal(info?.manual ? String(info.manual) : ''); }, [info?.manual]);

  const save = async (v: number | null) => {
    if (v !== null && !(v >= 0.5 && v <= 50)) { showToast(t('Hedef 0,5 ile 50 arasında olmalı.')); return; }
    setBusy(true);
    try { await axios.put(API, { client_id: clientId, target_roas: v }); showToast(t('Hedef kaydedildi.')); setSaved(true); setTimeout(() => setSaved(false), 2500); onChange(); }
    catch { showToast(t('Kaydedilemedi.')); }
    finally { setBusy(false); }
  };
  const fmt = (n: number | null | undefined) => (n ? `${n.toFixed(2).replace(/\.?0+$/, '')}×` : t('veri yok'));
  const chip: React.CSSProperties = { fontSize: 11.5, fontWeight: 700, padding: '4px 10px', borderRadius: 999, background: T.trackBg, color: T.textMid };

  return (
    <div style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: 14, padding: isMobile ? 14 : '16px 20px',
      display: 'flex', alignItems: isMobile ? 'stretch' : 'center', gap: isMobile ? 12 : 22, flexDirection: isMobile ? 'column' : 'row' }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 800, color: T.text }}>{t('Hedef ROAS')}</div>
        <div style={{ fontSize: 12, color: T.textMidAlt, lineHeight: 1.5, marginTop: 3 }}>
          {t('Şablonlardaki "hedefin altında / üstünde" koşulları bu değere göre çalışır. Girmezsen hesabının son 30 günlük ROAS\'ı referans alınır.')}
        </div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 8 }}>
          {info?.manual
            ? <span style={{ ...chip, background: T.greenTint, color: T.greenText }}>{t('Şu an kullanılan')}: {fmt(info.manual)}</span>
            : <>
                <span style={chip}>Meta: {fmt(info?.auto.meta)}{info?.auto.meta ? ` (${t('otomatik')})` : ''}</span>
                <span style={chip}>Google: {fmt(info?.auto.google)}{info?.auto.google ? ` (${t('otomatik')})` : ''}</span>
              </>}
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <input value={val} onChange={e => setVal(e.target.value.replace(',', '.'))} inputMode="decimal" placeholder={t('Hedef ROAS (×)')}
          style={{ width: isMobile ? '100%' : 140, padding: '9px 12px', borderRadius: 10, border: `1px solid ${T.borderMid}`, background: T.subtleBg,
            color: T.text, fontSize: 13, fontWeight: 700, outline: 'none', boxSizing: 'border-box' }} />
        <Button variant="solid" disabled={busy || !val} onClick={() => save(parseFloat(val))}>{saved ? `✓ ${t('Kaydedildi')}` : t('Kaydet')}</Button>
        {info?.manual ? <Button variant="ghost" disabled={busy} onClick={() => save(null)}>{t('Otomatiğe Dön')}</Button> : null}
      </div>
    </div>
  );
}
